import { render, staticRenderFns } from "./Side-Reports-Group.vue?vue&type=template&id=bccf22b2&"
import script from "./Side-Reports-Group.vue?vue&type=script&lang=js&"
export * from "./Side-Reports-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports